<ul
  class="cm-list"
  intGridContainer
  defaultColumnSize="1fr 1fr 1fr"
  gap="0.2rem"
  *ngIf="{cells: (cells$ | async)} as steams$"
>
  <li *ngFor="let cellData of steams$.cells; let i = index">
    <int-month-cell
      [cellData]="cellData"
      [pluginState]="pluginState"
      [selectedDates]="selectedDates"
      [markWeekends]="false"
      (onSelect)="onSelect($event)"
    >
      {{ months[i] }}
    </int-month-cell>
  </li>
</ul>
